import Header from "components/header/Header";
import AccountSetting from "pages/AccountSetting/AccountSetting";
import ContactUs from "pages/AccountSetting/section/contactUs/ContactUs";
import DocumentFiles from "pages/AccountSetting/section/documentRepository/DocumentFiles";
import DocumentFolders from "pages/AccountSetting/section/documentRepository/DocumentFolders";
import DocumentRepository from "pages/AccountSetting/section/documentRepository/DocumentRepository";
import MySites from "pages/AccountSetting/section/mySites/MySites";
import SiteDetails from "pages/AccountSetting/section/mySites/SiteDetails";
import UserProfile from "pages/AccountSetting/section/profile/UserProfile";
import PrivacyPolice from "pages/AccountSetting/section/terms/PrivacyPolice";
import TermsOfService from "pages/AccountSetting/section/terms/TermsOfService";
import Auth from "pages/auth/Auth";
import BillsReport from "pages/bills/BillsReport";
import ElectricityGeneration from "pages/bills/section/ElectricityGeneration";
import HomePage from "pages/homePage/HomePage";
import Report from "pages/report/Report";
import React from "react";
import { Outlet, Route, Routes } from "react-router-dom";

const Routing = () => {
  const WithHeader = () => {
    return (
      <>
        <div className="dashboard">
          <Header />
          <Outlet />
        </div>
      </>
    );
  };

  return (
    <>
      <Routes>
        <Route path="/" element={<Auth />} />
        <Route path="/" element={<WithHeader />}>
          <Route path="/dashboard" element={<HomePage />} />
          {/*if need dashboard then----> ?/:orderId */}
          <Route path="/report/:graphData?" element={<Report />} />
          <Route path="/bills/:orderId?" element={<BillsReport />} />
          <Route
            path="/bills/electricity-generation/:year/:month"
            element={<ElectricityGeneration />}
          />
          <Route path="" element={<AccountSetting />}>
            <Route path="/account" element={<UserProfile />} />
            <Route path="/sites" element={<MySites />} />
            <Route
              path="/sites/details/:folderName/:id"
              element={<SiteDetails />}
            />
            <Route
              path="/document-repository"
              element={<DocumentRepository />}
            />
            <Route
              path="/document-repository/folders/:folderName/:siteId"
              element={<DocumentFolders />}
            />
            <Route
              path="/document-repository/folders/files/:folderName/:siteId/:fileName/:folderId"
              element={<DocumentFiles />}
            />
            <Route path="contact-us" element={<ContactUs />} />
            <Route path="/privacy-policy" element={<PrivacyPolice />} />
            <Route path="/terms-of-service" element={<TermsOfService />} />
          </Route>
        </Route>
      </Routes>
    </>
  );
};

export default Routing;
